import { render, staticRenderFns } from "./history-ant.modal.vue?vue&type=template&id=371a0139&scoped=true"
import script from "./history-ant.modal.vue?vue&type=script&lang=js"
export * from "./history-ant.modal.vue?vue&type=script&lang=js"
import style0 from "./history-ant.modal.vue?vue&type=style&index=0&id=371a0139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a0139",
  null
  
)

export default component.exports